import apiClient from '../apiClient';
import { PUT_TOUR_GUIDE_URL } from '../apiUrl';

const putTourGuideApi = (id, data) => {
  return apiClient.put(PUT_TOUR_GUIDE_URL(id), data);
};

export default putTourGuideApi;
